const getIsLoggedIn = state => state.auth.isLoggedIn;
const getUserAvatar = state => state.auth.user.avatar;
const getUserEmail = state => state.auth.user.email;
const getUserName = state => state.auth.user.name;
const getIsBeingLoggedIn = state => state.auth.isBeingLoggedIn;
const getErrorRegister = state => state.auth.errorRegister;
const getErrorLogin = state => state.auth.errorLogin;

const authSelectors = {
  getIsLoggedIn,
  getUserAvatar,
  getUserEmail,
  getUserName,
  getIsBeingLoggedIn,
  getErrorRegister,
  getErrorLogin,
};

export default authSelectors;
